import React, { useState, useEffect } from 'react';
import './trackingPage.css'; // Assuming you have a CSS file for styling

const TrackingPage = () => {
  const [orderData, setOrderData] = useState(null);
  const [trackingData, setTrackingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Simulate API call - replace with your actual backend endpoint
  const fetchTrackingData = async () => {
    try {
      setLoading(true);
      
      
      // Mock data for demonstration
      const mockOrderData = {
        cardtype: "Premium Card",
        date: "26/04/2024",
        type: "Express Processing",
        name: "John Doe",
        purchaseno: "PO-2024-001",
        product: "Forex Card - USD",
        estimatedArrival: "30/04/2024"
      };

      const mockTrackingData = [
        {
          id: 1,
          date: "26/04/2024",
          processName: "Application Submitted",
          processStatus: "The Application has been submitted successfully",
          isCompleted: true
        },
        {
          id: 2,
          date: "27/04/2024",
          processName: "Document Verification",
          processStatus: "Documents are being verified",
          isCompleted: true
        },
        {
          id: 3,
          date: "28/04/2024",
          processName: "Processing",
          processStatus: "Your forex card is being processed",
          isCompleted: true
        },
        {
          id: 4,
          date: "29/04/2024",
          processName: "Quality Check",
          processStatus: "Final quality check in progress",
          isCompleted: false
        },
        {
          id: 5,
          date: "30/04/2024",
          processName: "Dispatch",
          processStatus: "Ready for dispatch",
          isCompleted: false
        }
      ];

      setOrderData(mockOrderData);
      setTrackingData(mockTrackingData);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch tracking data');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrackingData();
  }, []);

  if (loading) {
    return <div>Loading tracking information...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className='tracking-page'>
      {/* Order Header */}
      <div className="order-header">
        <div className="card-type">Card Type: {orderData?.cardtype}</div>
        <div className="application-date">Date Of Application: {orderData?.date}</div>
        <div className="processing-type">Processing Type: {orderData?.type}</div>
      </div>

      {/* Order Details */}
      <div className="order-details">
        <div className="details-header">
          <div>Name</div>
          <div>Purchase No.</div>
          <div>Product</div>
          <div>Estimated Arrival Time</div>
        </div>
        <div className="details-values">
          <div>{orderData?.name}</div>
          <div>{orderData?.purchaseno}</div>
          <div>{orderData?.product}</div>
          <div>{orderData?.estimatedArrival}</div>
        </div>
      </div>

      {/* Forex Tracker */}
      <div className='forex-tracker-container'>
        <div style={{fontWeight:'700',fontSize:'large'}}>Track Your Forex</div>
        <div className="forex-tracker">
          {trackingData.map((step, index) => (
            <div key={step.id} className="tracking-step">
              <div className={`status-indicator${step.isCompleted ? '-completed' : '-pending'}`}>
                <div>
                  <div></div>
                </div>
              </div>
              <div className="step-date">{step.date}</div>
              <div className="process-name">{step.processName}</div>
              <div className="process-status">{step.processStatus}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Refresh Button */}
      <button onClick={fetchTrackingData}>
        Refresh Tracking Data
      </button>
    </div>
  );
};

export default TrackingPage;